module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-vault-5.ad95d193.svg";